// CustomerSelectionModal.js
import React, { useState, useEffect, useContext, useRef } from 'react';
import 'datatables.net-bs5';
import $ from 'jquery';
import { ThemeContext } from "../../../Layout/Theme/ThemeContext";
import Draggable from 'react-draggable';
import Swal from 'sweetalert2';
function SupplierSelectionModal({ show, onClose, suppliers, onSelectSupplier, stockCategoryList, DiscountsList, CategoryID }) {
    const { theme, toggleTheme } = useContext(ThemeContext);
    let accordTheme = "accordion-header-light";
    if (theme == "dark") {
        accordTheme = "accordion-header-dark";
    }
    const handleFieldChange = (event) => {
        const { name, value } = event.target;
        setFormData({
            ...formData,
            [name]: value,
        });
    };
    const [formData, setFormData] = useState({ PK_SupplierCategory_ID: 0, FK_StockCategory_ID: CategoryID, FK_DiscountType_ID: 0, dec_Amount: 0 });
    const [selectedSuppliers, setSelectedSuppliers] = useState([]);
    const tableRef = useRef();
    const handleCheckboxChange = (supplier) => {
        setSelectedSuppliers((prev) => {
            const exists = prev.some(
                c => c.PK_Supplier_ID === supplier.PK_Supplier_ID
            );

            if (exists) {
                return prev.filter(
                    c => c.PK_Supplier_ID !== supplier.PK_Supplier_ID
                );
            }

            return [...prev, supplier];
        });
    };
    const initDataTable = () => {
        if ($.fn.DataTable.isDataTable(tableRef.current)) {
            $(tableRef.current).DataTable().destroy();
        }


        $(tableRef.current).DataTable({
            dom: '<"row"<"col-sm-6 d-flex align-items-center"Bf><"col-sm-6 d-flex justify-content-end"p>>rt',
            pagingType: 'full_numbers',
            language: {
                search: "_INPUT_",
                searchPlaceholder: "Search..."
            },

            lengthChange: false,
            initComplete: function () {

                $('.btn-dataTable').css('background', 'none');
                $('.btn-dataTable').css('border', 'none');
                $('.btn-dataTable').removeClass('btn-secondary');
                $('.btn-dataTable').removeClass('btn');
                $('.btn-dataTable').removeClass('btn-dataTable');
                //  $('.dt-search input[type="search"]').css('margin-left', '10px');
                //  $('.dt-search input[type="search"]').css('height', '25px');
            }
        });

        $('#datatable-search-container').append($('.dataTables_filter').html());
        $('.dataTables_filter').remove();
    };

    useEffect(() => {
        if (suppliers.length > 0) {
            initDataTable();
        }
    }, [suppliers]);
    const truncateText = (text, maxLength = 15) => {
        if (!text) return '';
        return text.length > maxLength ? text.slice(0, maxLength) + '...' : text;
    };
    const handleStart = (e, ui) => {
        e.stopPropagation();
    }
    const handleRowClick = (event, supplier) => {

        if (formData.FK_StockCategory_ID > 0 && formData.FK_DiscountType_ID) {
            onSelectSupplier(event, supplier, formData);
            onClose();
        }
        else {
            Swal.fire(
                'Error!',
                'Please select discount type first.',
                'error'
            );
        }
    };
    const handleSubmit = async () => {

        if (formData.FK_StockCategory_ID <= 0 || formData.FK_DiscountType_ID <= 0) {
            Swal.fire(
                'Error!',
                'Please select Discount Type.',
                'error'
            );
            return;
        }

        if (selectedSuppliers.length === 0) {
            Swal.fire(
                'Error!',
                'Please select at least one customer.',
                'error'
            );
            return;
        }
        
        await onSelectSupplier(selectedSuppliers, formData);
    };
    return (
        <div className={`modal fade ${show ? 'show' : ''}`} style={{ display: show ? 'block' : 'none', "marginTop": "50px" }} tabIndex="-1">
            <div className="modal-dialog modal-lg">
                <Draggable handle=".modal-header" onStart={handleStart}>
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Select Suppliers</h5>
                            <button type="button" className="btn-close" onClick={onClose} aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="row mb-3" style={{ "marginLeft": "5px", "marginRight": "0px", "marginTop": "10px" }}>

                                <label htmlFor="FK_DiscountType_ID" className="col-sm-3 col-form-label">Discount Type:</label>
                                <div className="col-sm-3">
                                    <select name="FK_DiscountType_ID" className='form-control' value={formData.FK_DiscountType_ID} onChange={handleFieldChange}>
                                        <option value="0">Select Discount</option>
                                        {DiscountsList.map((discount) => (
                                            <option key={discount.PK_DiscountType_ID} value={discount.PK_DiscountType_ID}>
                                                {discount.vc_Name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <label htmlFor="dec_Amount" className="col-sm-3 col-form-label">Amount</label>
                                <div className="col-sm-3">
                                    <input type="text" className="form-control" name="dec_Amount" value={formData.dec_Amount} onChange={handleFieldChange} />
                                </div>
                            </div>

                            <div style={{ "marginLeft": "10px", "marginRight": "0px", "marginTop": "10px" }}>
                                <table className="table table-striped" ref={tableRef} style={{ "width": "100%" }}>
                                    <thead>
                                        <tr>
                                            <th></th>
                                            <th className="no-wrap">Supplier</th>
                                            <th className="no-wrap">Address</th>
                                            <th className="no-wrap">Telephone</th>
                                            <th className="no-wrap">Fax</th>
                                            <th className="no-wrap">Website</th>
                                            <th className="no-wrap">Account Ref</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {suppliers.map(supplier => (
                                            <tr key={supplier.PK_Supplier_ID} style={{ cursor: 'pointer' }}>
                                                <td>
                                                    <input
                                                        type="checkbox"
                                                        checked={selectedSuppliers.some(
                                                            c => c.PK_Supplier_ID === supplier.PK_Supplier_ID
                                                        )}
                                                        onChange={() => handleCheckboxChange(supplier)}
                                                    />
                                                </td>
                                                <td className="no-wrap">{truncateText(supplier.vc_SupplierName)}</td>
                                                <td className="no-wrap">{truncateText(supplier.vc_Address1)}</td>
                                                <td className="no-wrap">{truncateText(supplier.vc_Phone)}</td>
                                                <td className="no-wrap">{supplier.vc_Fax}</td>
                                                <td className="no-wrap">{supplier.vc_Website}</td>
                                                <td className="no-wrap">{supplier.vc_AccountRef}</td>
                                            </tr>
                                        ))}
                                    </tbody>

                                </table>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button
                                className="btn btn-secondary"
                                onClick={onClose}
                            >
                                Close
                            </button>

                            <button
                                className="btn btn-primary"
                                onClick={handleSubmit}
                            >
                                Submit
                            </button>
                        </div>
                    </div>
                </Draggable>
            </div>
        </div>
    );
}

export default SupplierSelectionModal;
